export default __webpack_public_path__ + "static/media/female_ponytail.17981cbd.png";